import * as CarModels from "../../models/car/car";
import * as Models from "../../models/commonModels";
import * as GarageVisitsModels from '../../models/garage-visits/garage-visits';
import * as DepoisteModels from "../../models/deposite/deposite";
import * as GarageModels from "../../models/garage/garage";
import * as TyreOrderModels from "../../models/tyre-order/tyre-order";

export class CarSet {
  static readonly type = "[Ald] Car Set";
  constructor(public Car: Models.Request<CarModels.CarModel>) {}
}

export class CarGet {
  static readonly type = "[Ald] Car Get";
  constructor(public Car: Models.RequestModel) {}
}

export class VisitsGet {
  static readonly type = "[Ald] Visits Get";
  constructor(public Car: Models.RequestModel) {}
}

export class DepositesGet {
  static readonly type = "[Ald] Deposites Get";
  constructor(public Car: Models.RequestModel) { }
}

export class TyreOrdersGet {
  static readonly type = "[Ald] Tyre Orders Get";
  constructor(public Car: Models.RequestModel) { }
}

export class RelocationOrdersGet {
  static readonly type = "[Ald] Relocation Orders Get";
  constructor(public Car: Models.RequestModel) { }
}

export class DepositeGet {
  static readonly type = "[Ald] Deposite Get";
  constructor(public Deposite: Models.RequestModel) { }
}

export class GarageVisitCreate {
  static readonly type = '[Ald] Garage Visit Create';
  constructor(public GarageVisit: Models.ContextRequest<CarModels.CarModel,GarageVisitsModels.GarageVisitModel>) { }
}

export class SummaryGet {
  static readonly type = "[Ald] Summary Get";
  constructor(public Car: Models.RequestModel) { }
}

export class TyreOrderGet {
  static readonly type = "[Ald] Tyre Order Get";
  constructor(public TyreOrder: Models.RequestModel) { }
}

export class RelocationOrderGet {
  static readonly type = "[Ald] Relocatoin Order Get";
  constructor(public RelocatoinOrder: Models.RequestModel) { }
}

export class RelocationOrderCreate {
  static readonly type = "[Ald] Relocatoin Order Create";
  constructor(public RelocatoinOrder: Models.ContextRequest<DepoisteModels.DepositeModel, GarageModels.GaragePreviewModel>) { }
}

export class RelocationGarageGet {
  static readonly type = "[Ald] Relocatoin Garage Get";
  constructor(public Deposite: Models.Request<DepoisteModels.DepositeModel>) { }
}

export class GarageVisitRequestForDeposite {
  static readonly type = "[Ald] Garage Visit Request For Deposite";
  constructor(public Deposite: Models.Request<DepoisteModels.DepositeModel>) { }
}

export class GarageVisitRequestForTyreOrder {
  static readonly type = "[Ald] Garage Visit Request For TyreOrder";
  constructor(public TyreOrder: Models.Request<TyreOrderModels.TyreOrderModel>) { }
}

export class AvailableDefaultGarageGet {
  static readonly type = "[Ald] Default Garage Get";
  constructor(public Car: Models.RequestModel) { }
}

export class DefaultGarageSet {
  static readonly type = "[Ald] Default Garage Set";
  constructor(public Garage: Models.Request<GarageModels.GaragePreviewModel>) { }
}

export class SendMessage {
  static readonly type = "[Ald] Send Message";
  constructor(public Message: Models.Request<string>) { }
}
